module.exports = __webpack_public_path__ + "media/images/vouchers/hydro-b118d6725bb35827bf77d1fb75664918.png";